import { AssignmentTurnedIn, Phone, Pin, Video } from "@gigpro/ui/Icons";
import { STATUS_BUCKETS } from "domains/hire/constants/statusBuckets";
import type { FilterOption } from "domains/schedule/components/Filters/types";

// Sentinels: can't collide with a posting uuid.
export const AVAILABILITY_OFF = "off";
export const AVAILABILITY_MINE = "mine";

export const typeOptions = [
  { id: "working", name: "Working", icon: AssignmentTurnedIn },
  { id: "phone", name: "Phone", icon: Phone },
  { id: "video", name: "Video", icon: Video },
  { id: "in_person", name: "In-person", icon: Pin },
] as const satisfies ReadonlyArray<FilterOption<string>>;
export type TypeId = (typeof typeOptions)[number]["id"];
export const typeIds = typeOptions.map(({ id }) => id);

export const statusOptions = STATUS_BUCKETS.map(({ id, name, control }) => ({
  id,
  name,
  controlClassName: control,
})) satisfies ReadonlyArray<FilterOption<string>>;
export const statusIds = STATUS_BUCKETS.map(({ id }) => id);

// Backend excludes DECLINED/CANCELLED from the feed today, so these default off.
export const defaultStatusIds = statusIds.filter((id) => id !== "cancelled" && id !== "declined");
